import { defineMessages } from 'react-intl';

export default defineMessages({
    plQuoteValidityDays: {
        id: 'quoteandbind.views.pel.quote.Quote Validity Days',
        defaultMessage: 'THIS QUOTE IS VALID FOR {quoteValidityDays} DAYS - COVERAGE IS NOT BOUND UNTIL A BINDER IS ISSUED',
    },
});
